module.exports = __webpack_public_path__ + "static/media/service-center-pelayanan-ke-rumah.5748b8fb.jpg";